import { Box, LinearProgress, Theme, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInvestorData } from '../../redux-store/actions/userManagement';
import { RootStateType } from '../../redux-store/reducers';
import {
  ProductSchemeDetailsType,
  ProductTransactionsEntity,
} from '../../redux-store/types/api-types';
import { formatToIndianCurrency } from '../../utils/utilityFunctions';
import { DataTable } from '../DataTable';
import { formatLongDate } from '../../utils/date';
import { AmountUnit } from '../commonComponents';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import CustomTable from '../investorOverview/common/customTable';
import MutualFundSchemeDetailBody from './table/MutualFundSchemeBody';
import { Order, PaginationObj, SortingObj, TableHeaderData } from '../investorOverview/types';
import MutualFundTranscationBody from './table/MutualFundTranscationBody';
import { GetTransactionDetailsResponseBody, TransactionDetailsData } from '../../redux-store/types/products';
import { getTransactionDetails } from '../../redux-store/actions/product';

// export default function TransactionDetails({
//   investorId,
//   selectedFilters,
// }: {
//   investorId: string;
//   selectedFilters: { [key: string]: string[] };
// }): JSX.Element {
//   const [isLoading, setLoading] = useState(false);
//   const [schemeDetailsData, setSchemeDetailsData] = useState<ProductSchemeDetailsType | null>(null);
//   const valueConverter = useSelector((state:any)=> state.valueConverter);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     let isComponentActive = true;
//     setSchemeDetailsData(null);
//     (async function () {
//       try {
//         setLoading(true);
//         const response = (await dispatch(
//           getInvestorData({
//             productLevel: 'MUTUAL FUNDS',
//             filters: {
//               ...selectedFilters,
//               customers: investorId ? [investorId] : [],
//             },
//             required: ['schemeDetails'],
//           })
//         )) as unknown as ProductSchemeDetailsType;
//         if (!isComponentActive) {
//           return;
//         }
//         setSchemeDetailsData(response);
//         setLoading(false);
//       } catch (e) {
//         setLoading(false);
//         console.log((e as Error).message);
//       }
//     })();
//     return () => {
//       isComponentActive = false;
//     };
//   }, [selectedFilters]);

//   const headers = [
//     {
//       header: 'Scheme',
//       sortingKey: 'ProductName',
//       valueGetter: (row: ProductTransactionsEntity) => row?.ProductName || 'N/A',
//     },
//     {
//       header: 'Scheme Category',
//       sortingKey: 'Sub_AssetclassName',
//       valueGetter: (row: ProductTransactionsEntity) => row?.Sub_AssetclassName || 'N/A',
//     },
//     {
//       header: 'Transaction Amount',
//       sortingKey: 'Amount',
//       valueGetter: (row: ProductTransactionsEntity, amountUnit?: number | null | undefined) =>
//         row?.Amount || row?.Amount === 0 ? formatToIndianCurrency(row?.Amount, amountUnit) : 'N/A',
//     },
//     {
//       header: 'Transaction Type',
//       sortingKey: 'TranType',
//       valueGetter: (row: ProductTransactionsEntity) => row?.TranType || 'N/A',
//     },
//     {
//       header: 'Transaction Date',
//       sortingKey: 'TranDt',
//       valueGetter: (row: ProductTransactionsEntity) =>
//         row.TranDt ? formatLongDate(row.TranDt) : 'N/A',
//     },
//   ];
//   return (
//     <Box>
//       <Box
//         sx={{
//           mb: 3
//         }}>
//           <AmountUnit />
//           {/* <SaveAltRoundedIcon
//         onClick={() => window.print()}

//         sx={{
//           marginLeft: '20px',
//           color: '#22242C',
//           opacity:'0.7',
//           fontSize:'1.7rem',
//           cursor:'pointer',
//           borderRadius:'13px',
//           '&:hover': { backgroundColor:'#E7E6E6' },
//         }} /> */}
//         </Box>
//       <Box
//         sx={{
//           mb: 7,
//         }}>
//         {isLoading ? (
//           <LinearProgress />
//         ) : (
//           <Box>
//             {schemeDetailsData && (
//               <>
//                 <DataTable
//                   isLoading={isLoading}
//                   tableHeader={headers}
//                   tableData={schemeDetailsData?.schemeTransactions}
//                   rowCustomStyles={{
//                     '&:last-child td, &:last-child th': { border: 0 },
//                     '.MuiTableCell-body ': { color: '#686e72' },
//                     '& .MuiTableCell-root': {
//                       textAlign: 'left',
//                     },
//                     background: 'transparent',
//                   }}
//                   tableHeaderCustomStyles={{
//                     '& .MuiTableCell-root': {
//                       textAlign: 'left',
//                     },
//                   }}
//                   boxStyles={{ minHeight: 'unset', maxHeight: '500px', minWidth: 450 }}
//                   customEmptyMessage="No transactions undertaken in the last 30 days"
//                 />
//               </>
//             )}
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// }

const tableHeaderData: TableHeaderData[] = [
  {
    id: "schemeName",
    label: "SCHEME",
    align: "left",
    isSortable: false
  },
  {
    id: "schemeCategory",
    label: "SCHEME CATEGORY",
    align: "center",
    isSortable: false
  },
  {
    id: "amount",
    label: "TRANSACTION AMOUNT",
    align: "center",
    isSortable: true
  },
  {
    id: "units",
    label: "TRANSACTION UNITS",
    align: "center",
    isSortable: true
  },
  {
    id: "type",
    label: "TRANSACTION TYPE",
    align: "center",
    isSortable: false
  },
  {
    id: "date",
    label: "TRANSACTION DATE",
    align: "center",
    isSortable: true
  },
]

interface FetchDataArgs {
  sortItem?: string;
  order?: Order;
  currentPage?: number;
  rowsPerPage?: number;
}

interface TransactionDetailProps {
  transactionDetailsLoading: boolean;
  setTransactionDetailsLoading: React.Dispatch<React.SetStateAction<boolean>>
  transactionTableData: TransactionDetailsData[];
  setTransactionTableData: React.Dispatch<React.SetStateAction<TransactionDetailsData[]>>
  transactionDetailPaginationObj: PaginationObj;
  setTransactionDetailPaginationObj: React.Dispatch<React.SetStateAction<PaginationObj>>
  fetchTransactionDetailsData: any
  transactionDetailsData: GetTransactionDetailsResponseBody
}


export default function TransactionDetails(props: TransactionDetailProps): JSX.Element {
  const { transactionDetailsLoading, transactionTableData, transactionDetailPaginationObj, setTransactionDetailPaginationObj, fetchTransactionDetailsData, transactionDetailsData } = props;

  const { palette } = useTheme()
  const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
    order: "desc",
    orderBy: "date"
  })

  const handleSort = (orderBy: string, order: Order) => {
    setTableSortingObj({
      order,
      orderBy
    })

    fetchTransactionDetailsData({
      sortItem: orderBy,
      order,
      currentPage: transactionDetailPaginationObj.currentPage + 1,
      rowsPerPage: transactionDetailPaginationObj.rowsPerPage
    })
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTransactionDetailPaginationObj(prevState => ({
      ...prevState,
      rowsPerPage: Number(event.target.value),
      currentPage: 0,
    }))

    fetchTransactionDetailsData({
      rowsPerPage: Number(event.target.value),
      sortItem: tableSortingObj.orderBy,
      order: tableSortingObj.order,
    })
  }

  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setTransactionDetailPaginationObj(prevState => ({
      ...prevState,
      currentPage: page
    }))

    fetchTransactionDetailsData({
      currentPage: page + 1,
      sortItem: tableSortingObj.orderBy,
      order: tableSortingObj.order,
      rowsPerPage: transactionDetailPaginationObj.rowsPerPage
    })
  }

  return (
    <>
      <Box
        p={'35px'}
        boxShadow={1}
        sx={{
          background: palette.background.paper,
          borderRadius: '25px'
        }}
      >
        {(!transactionDetailsLoading && !transactionDetailsData?.isSuccess) ? <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}
        >
          <Typography
            variant="body_600"
            sx={(theme: Theme) => ({
              fontWeight: 500,
              lineHeight: "22.5px",
              letterSpacing: "0.01px",
              color: theme.palette.text.primary
            })}
          >
            Something went wrong. Please try again.
          </Typography>
        </Box> : <CustomTable
          isLoading={transactionDetailsLoading}
          tableBody={
            <MutualFundTranscationBody
              tableBodyData={transactionTableData}
              tableBodyRowCustomStyles={{
                '& td:first-child': {
                  paddingLeft: "0px",
                },
                '& td': {
                  padding: "16px",
                },
              }}
            />
          }
          tableData={transactionTableData}
          tableHeaderData={tableHeaderData}
          handleSort={handleSort}
          tableDataCount={transactionDetailPaginationObj.totalRows}
          rowsPerPage={transactionDetailPaginationObj.rowsPerPage}
          rowsPerPageOptions={[5, 10, 15, 20]}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handlePageChange={handlePageChange}
          currentPage={transactionDetailPaginationObj.currentPage}
          order={tableSortingObj.order}
          orderBy={tableSortingObj.orderBy}
          tableHeadRowCustomStyles={{
            '& th:first-child': {
              paddingLeft: "0px"
            }
          }}
          tableBodyCustomStyles={{
            '& tr:last-child td': {
              border: '1px'
            }
          }}
        />}
      </Box>
    </>
  )
}
